import { Box, keyframes, styled } from "@mui/material";

const bounce = keyframes`
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
`

const Dot = styled(Box)<{ size: string; backgroundColor?: string }>(({ theme, size, backgroundColor }) => ({
  width: size,
  height: size,
  margin: "0 4px",
  borderRadius: "50%",
  display: "inline-block",
  backgroundColor: backgroundColor ?? (theme.palette.mode === "light" ? "#000" : "#ffffff"),
  animation: `${bounce} 1.4s infinite ease-in-out both`
}))

const ThreeDotsLoader = ({ size = "12px", backgroundColor }: { size?: string; backgroundColor?: string }) => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center">
      <Dot size={size} backgroundColor={backgroundColor} style={{ animationDelay: "0s" }} />
      <Dot size={size} backgroundColor={backgroundColor} style={{ animationDelay: "0.2s" }} />
      <Dot size={size} backgroundColor={backgroundColor} style={{ animationDelay: "0.4s" }} />
    </Box>
  )
}

export default ThreeDotsLoader
